import React from 'react';
import { CountryOption } from './countrySelect';
import {
  CambodiaFlagIcon,
  ChinaFlagIcon,
  MalaysiaFlagIcon,
  VietnamFlagIcon,
  SingaporeFlagIcon,
  IndonesiaFlagIcon,
  PhilippinesFlagIcon,
  MyanmarFlagIcon,
  LaosFlagIcon,
} from '../../../../../assets-module/asset-configuration/icon/iconExporter/iconExporter';

// Export country options
export const defaultCountryOptions: CountryOption[] = [
  {
    code: '+855',
    name: 'Cambodia',
    dialCode: '+855',
    flag: <CambodiaFlagIcon />
  },
  {
    code: '+86',
    name: 'China',
    dialCode: '+86',
    flag: <ChinaFlagIcon />
  },
  {
    code: '+60',
    name: 'Malaysia',
    dialCode: '+60',
    flag: <MalaysiaFlagIcon />
  },
  {
    code: '+84',
    name: 'Vietnam',
    dialCode: '+84',
    flag: <VietnamFlagIcon />
  },
  {
    code: '+65',
    name: 'Singapore',
    dialCode: '+65',
    flag: <SingaporeFlagIcon />
  },
  {
    code: '+62',
    name: 'Indonesia',
    dialCode: '+62',
    flag: <IndonesiaFlagIcon />
  },
  {
    code: '+63',
    name: 'Philippines',
    dialCode: '+63',
    flag: <PhilippinesFlagIcon />
  },
  {
    code: '+95',
    name: 'Myanmar',
    dialCode: '+95',
    flag: <MyanmarFlagIcon />
  },
  {
    code: '+856',
    name: 'Laos',
    dialCode: '+856',
    flag: <LaosFlagIcon />
  }
];

export default defaultCountryOptions;
